import { render } from "./PixelDetails.vue?vue&type=template&id=30d7fe8e"
import script from "./PixelDetails.vue?vue&type=script&lang=js"
export * from "./PixelDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__